import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ViewListIcon from "@mui/icons-material/ViewList";
import BarChartIcon from "@mui/icons-material/BarChart";
import TimelineIcon from "@mui/icons-material/Timeline";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from "@mui/material/Tooltip";

const defaultButton = {
  title: "",
  icon: ViewListIcon,
  view: "",
};
function Chart({ initView, variants, table, chart }) {
  const { t } = useTranslation();
  const [view, setView] = useState("");

  useEffect(() => {
    setView(initView);
  }, [initView]);

  const handleChange = (event, nextView) => {
    if (nextView) setView(nextView);
  };

  const toggleButtons = {
    table: {
      title: t("timeline.buttons.table"),
      icon: <ViewListIcon fontSize="small" />,
      view: table,
    },
    barChart: {
      title: t("timeline.buttons.barChart"),
      icon: <BarChartIcon fontSize="small" />,
      view: chart,
    },
    lineChart: {
      title: t("timeline.title"),
      icon: <TimelineIcon fontSize="small" />,
      view: chart,
    },
  };

  const getTooltipPlacement = (index) => {
    if (index === 0) return "top";
    return "bottom";
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        gap: 16,
        justifyContent: "space-between",
      }}
    >
      <div style={{ width: "100%" }}>
        {toggleButtons?.[view]?.view ?? defaultButton.view}
      </div>
      <ToggleButtonGroup
        orientation="vertical"
        size="small"
        value={view}
        exclusive
        onChange={handleChange}
      >
        {variants.map((id, index) => {
          if (!variants.includes(id)) return null;
          const button = toggleButtons?.[id] ?? defaultButton;
          return (
            <ToggleButton key={id} value={id} aria-label={button.title}>
              <Tooltip
                title={button.title}
                placement={getTooltipPlacement(index)}
              >
                {button.icon}
              </Tooltip>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </div>
  );
}

export default Chart;
